package es.cragma.fichajefacil

import androidx.compose.runtime.Composable
import androidx.compose.ui.tooling.preview.Preview
import es.cragma.fichajefacil.ui.AppNavigation

@Composable
@Preview
fun App(
    onGoogleSignInRequested: ((onSuccess: (email: String) -> Unit) -> Unit)? = null,
    onAppleSignInRequested: ((onSuccess: (email: String) -> Unit) -> Unit)? = null,
    onRequestGpsLocation: ((onResult: (DeviceLocation?) -> Unit) -> Unit)? = null
) {
    AppNavigation(
        onGoogleSignInRequested = onGoogleSignInRequested,
        onAppleSignInRequested = onAppleSignInRequested,
        onRequestGpsLocation = onRequestGpsLocation
    )
}
